"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _BaseCarrierRelationship = _interopRequireDefault(require("./BaseCarrierRelationship"));

var _BaseCarrierRelationshipCarrierDirectIntegrationProfile = _interopRequireDefault(require("./BaseCarrierRelationshipCarrierDirectIntegrationProfile"));

var _CarrierDriver = _interopRequireDefault(require("./CarrierDriver"));

var _CarrierInsurance = _interopRequireDefault(require("./CarrierInsurance"));

var _CarrierPointOfContact = _interopRequireDefault(require("./CarrierPointOfContact"));

var _CarrierReferenceCode = _interopRequireDefault(require("./CarrierReferenceCode"));

var _CarrierTag = _interopRequireDefault(require("./CarrierTag"));

var _Company = _interopRequireDefault(require("./Company"));

var _FmcsaCensusData = _interopRequireDefault(require("./FmcsaCensusData"));

var _SlimCarrierRelationshipAllOf = _interopRequireDefault(require("./SlimCarrierRelationshipAllOf"));

var _SlimRMISCarrierStatus = _interopRequireDefault(require("./SlimRMISCarrierStatus"));

var _SlimSaferWatchCarrierStatus = _interopRequireDefault(require("./SlimSaferWatchCarrierStatus"));

var _SlimUser = _interopRequireDefault(require("./SlimUser"));

var _User = _interopRequireDefault(require("./User"));

var _VendorFactoringCompany = _interopRequireDefault(require("./VendorFactoringCompany"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The SlimCarrierRelationship model module.
 * @module model/SlimCarrierRelationship
 * @version 2.7.64
 */
var SlimCarrierRelationship = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SlimCarrierRelationship</code>.
   * @alias module:model/SlimCarrierRelationship
   * @implements module:model/BaseCarrierRelationship
   * @implements module:model/SlimCarrierRelationshipAllOf
   */
  function SlimCarrierRelationship() {
    _classCallCheck(this, SlimCarrierRelationship);

    _BaseCarrierRelationship["default"].initialize(this);

    _SlimCarrierRelationshipAllOf["default"].initialize(this);

    SlimCarrierRelationship.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(SlimCarrierRelationship, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>SlimCarrierRelationship</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SlimCarrierRelationship} obj Optional instance to populate.
     * @return {module:model/SlimCarrierRelationship} The populated <code>SlimCarrierRelationship</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SlimCarrierRelationship();

        _BaseCarrierRelationship["default"].constructFromObject(data, obj);

        _SlimCarrierRelationshipAllOf["default"].constructFromObject(data, obj);

        if (data.hasOwnProperty('bill_to_vendor_by_default')) {
          obj['bill_to_vendor_by_default'] = _ApiClient["default"].convertToType(data['bill_to_vendor_by_default'], 'Boolean');
        }

        if (data.hasOwnProperty('carrier_direct_integration_profile')) {
          obj['carrier_direct_integration_profile'] = _BaseCarrierRelationshipCarrierDirectIntegrationProfile["default"].constructFromObject(data['carrier_direct_integration_profile']);
        }

        if (data.hasOwnProperty('carrier_owner')) {
          obj['carrier_owner'] = _User["default"].constructFromObject(data['carrier_owner']);
        }

        if (data.hasOwnProperty('carrier_reference_codes')) {
          obj['carrier_reference_codes'] = _ApiClient["default"].convertToType(data['carrier_reference_codes'], [_CarrierReferenceCode["default"]]);
        }

        if (data.hasOwnProperty('carrier_status')) {
          obj['carrier_status'] = _ApiClient["default"].convertToType(data['carrier_status'], 'String');
        }

        if (data.hasOwnProperty('carrier_status_last_updated')) {
          obj['carrier_status_last_updated'] = _ApiClient["default"].convertToType(data['carrier_status_last_updated'], 'Date');
        }

        if (data.hasOwnProperty('carrier_status_updated_by')) {
          obj['carrier_status_updated_by'] = _SlimUser["default"].constructFromObject(data['carrier_status_updated_by']);
        }

        if (data.hasOwnProperty('created_at')) {
          obj['created_at'] = _ApiClient["default"].convertToType(data['created_at'], 'Date');
        }

        if (data.hasOwnProperty('drivers')) {
          obj['drivers'] = _ApiClient["default"].convertToType(data['drivers'], [_CarrierDriver["default"]]);
        }

        if (data.hasOwnProperty('exclude_from_automated_carrier_status')) {
          obj['exclude_from_automated_carrier_status'] = _ApiClient["default"].convertToType(data['exclude_from_automated_carrier_status'], 'Boolean');
        }

        if (data.hasOwnProperty('external_payment_processor_id')) {
          obj['external_payment_processor_id'] = _ApiClient["default"].convertToType(data['external_payment_processor_id'], 'String');
        }

        if (data.hasOwnProperty('external_payment_processor_sync_status')) {
          obj['external_payment_processor_sync_status'] = _ApiClient["default"].convertToType(data['external_payment_processor_sync_status'], 'String');
        }

        if (data.hasOwnProperty('fmcsa_census_data')) {
          obj['fmcsa_census_data'] = _FmcsaCensusData["default"].constructFromObject(data['fmcsa_census_data']);
        }

        if (data.hasOwnProperty('fmcsa_vendor')) {
          obj['fmcsa_vendor'] = _Company["default"].constructFromObject(data['fmcsa_vendor']);
        }

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('insurance_records')) {
          obj['insurance_records'] = _ApiClient["default"].convertToType(data['insurance_records'], [_CarrierInsurance["default"]]);
        }

        if (data.hasOwnProperty('is_editable')) {
          obj['is_editable'] = _ApiClient["default"].convertToType(data['is_editable'], 'Boolean');
        }

        if (data.hasOwnProperty('notes')) {
          obj['notes'] = _ApiClient["default"].convertToType(data['notes'], 'String');
        }

        if (data.hasOwnProperty('point_of_contacts')) {
          obj['point_of_contacts'] = _ApiClient["default"].convertToType(data['point_of_contacts'], [_CarrierPointOfContact["default"]]);
        }

        if (data.hasOwnProperty('shipwell_vendor')) {
          obj['shipwell_vendor'] = _Company["default"].constructFromObject(data['shipwell_vendor']);
        }

        if (data.hasOwnProperty('tags')) {
          obj['tags'] = _ApiClient["default"].convertToType(data['tags'], [_CarrierTag["default"]]);
        }

        if (data.hasOwnProperty('updated_at')) {
          obj['updated_at'] = _ApiClient["default"].convertToType(data['updated_at'], 'Date');
        }

        if (data.hasOwnProperty('vendor_factoring_company')) {
          obj['vendor_factoring_company'] = _VendorFactoringCompany["default"].constructFromObject(data['vendor_factoring_company']);
        }

        if (data.hasOwnProperty('rmis_carrier_statuses')) {
          obj['rmis_carrier_statuses'] = _ApiClient["default"].convertToType(data['rmis_carrier_statuses'], [_SlimRMISCarrierStatus["default"]]);
        }

        if (data.hasOwnProperty('saferwatch_carrier_statuses')) {
          obj['saferwatch_carrier_statuses'] = _ApiClient["default"].convertToType(data['saferwatch_carrier_statuses'], [_SlimSaferWatchCarrierStatus["default"]]);
        }
      }

      return obj;
    }
  }]);

  return SlimCarrierRelationship;
}();
/**
 * Whether or not the vendor requests that they be assigned as the bill-to party when they get tendered loads. Setting is read-only, and will not be present when this object is part of a list. 
 * @member {Boolean} bill_to_vendor_by_default
 */


SlimCarrierRelationship.prototype['bill_to_vendor_by_default'] = undefined;
/**
 * @member {module:model/BaseCarrierRelationshipCarrierDirectIntegrationProfile} carrier_direct_integration_profile
 */

SlimCarrierRelationship.prototype['carrier_direct_integration_profile'] = undefined;
/**
 * @member {module:model/User} carrier_owner
 */

SlimCarrierRelationship.prototype['carrier_owner'] = undefined;
/**
 * @member {Array.<module:model/CarrierReferenceCode>} carrier_reference_codes
 */

SlimCarrierRelationship.prototype['carrier_reference_codes'] = undefined;
/**
 * @member {module:model/SlimCarrierRelationship.CarrierStatusEnum} carrier_status
 */

SlimCarrierRelationship.prototype['carrier_status'] = undefined;
/**
 * @member {Date} carrier_status_last_updated
 */

SlimCarrierRelationship.prototype['carrier_status_last_updated'] = undefined;
/**
 * @member {module:model/SlimUser} carrier_status_updated_by
 */

SlimCarrierRelationship.prototype['carrier_status_updated_by'] = undefined;
/**
 * @member {Date} created_at
 */

SlimCarrierRelationship.prototype['created_at'] = undefined;
/**
 * @member {Array.<module:model/CarrierDriver>} drivers
 */

SlimCarrierRelationship.prototype['drivers'] = undefined;
/**
 * @member {Boolean} exclude_from_automated_carrier_status
 */

SlimCarrierRelationship.prototype['exclude_from_automated_carrier_status'] = undefined;
/**
 * @member {String} external_payment_processor_id
 */

SlimCarrierRelationship.prototype['external_payment_processor_id'] = undefined;
/**
 * @member {module:model/SlimCarrierRelationship.ExternalPaymentProcessorSyncStatusEnum} external_payment_processor_sync_status
 */

SlimCarrierRelationship.prototype['external_payment_processor_sync_status'] = undefined;
/**
 * @member {module:model/FmcsaCensusData} fmcsa_census_data
 */

SlimCarrierRelationship.prototype['fmcsa_census_data'] = undefined;
/**
 * @member {module:model/Company} fmcsa_vendor
 */

SlimCarrierRelationship.prototype['fmcsa_vendor'] = undefined;
/**
 * @member {String} id
 */

SlimCarrierRelationship.prototype['id'] = undefined;
/**
 * @member {Array.<module:model/CarrierInsurance>} insurance_records
 */

SlimCarrierRelationship.prototype['insurance_records'] = undefined;
/**
 * @member {Boolean} is_editable
 */

SlimCarrierRelationship.prototype['is_editable'] = undefined;
/**
 * @member {String} notes
 */

SlimCarrierRelationship.prototype['notes'] = undefined;
/**
 * @member {Array.<module:model/CarrierPointOfContact>} point_of_contacts
 */

SlimCarrierRelationship.prototype['point_of_contacts'] = undefined;
/**
 * @member {module:model/Company} shipwell_vendor
 */

SlimCarrierRelationship.prototype['shipwell_vendor'] = undefined;
/**
 * @member {Array.<module:model/CarrierTag>} tags
 */

SlimCarrierRelationship.prototype['tags'] = undefined;
/**
 * @member {Date} updated_at
 */

SlimCarrierRelationship.prototype['updated_at'] = undefined;
/**
 * @member {module:model/VendorFactoringCompany} vendor_factoring_company
 */

SlimCarrierRelationship.prototype['vendor_factoring_company'] = undefined;
/**
 * @member {Array.<module:model/SlimRMISCarrierStatus>} rmis_carrier_statuses
 */

SlimCarrierRelationship.prototype['rmis_carrier_statuses'] = undefined;
/**
 * @member {Array.<module:model/SlimSaferWatchCarrierStatus>} saferwatch_carrier_statuses
 */

SlimCarrierRelationship.prototype['saferwatch_carrier_statuses'] = undefined; // Implement BaseCarrierRelationship interface:

/**
 * Whether or not the vendor requests that they be assigned as the bill-to party when they get tendered loads. Setting is read-only, and will not be present when this object is part of a list. 
 * @member {Boolean} bill_to_vendor_by_default
 */

_BaseCarrierRelationship["default"].prototype['bill_to_vendor_by_default'] = undefined;
/**
 * @member {module:model/BaseCarrierRelationshipCarrierDirectIntegrationProfile} carrier_direct_integration_profile
 */

_BaseCarrierRelationship["default"].prototype['carrier_direct_integration_profile'] = undefined;
/**
 * @member {module:model/User} carrier_owner
 */

_BaseCarrierRelationship["default"].prototype['carrier_owner'] = undefined;
/**
 * @member {Array.<module:model/CarrierReferenceCode>} carrier_reference_codes
 */

_BaseCarrierRelationship["default"].prototype['carrier_reference_codes'] = undefined;
/**
 * @member {module:model/BaseCarrierRelationship.CarrierStatusEnum} carrier_status
 */

_BaseCarrierRelationship["default"].prototype['carrier_status'] = undefined;
/**
 * @member {Date} carrier_status_last_updated
 */

_BaseCarrierRelationship["default"].prototype['carrier_status_last_updated'] = undefined;
/**
 * @member {module:model/SlimUser} carrier_status_updated_by
 */

_BaseCarrierRelationship["default"].prototype['carrier_status_updated_by'] = undefined;
/**
 * @member {Date} created_at
 */

_BaseCarrierRelationship["default"].prototype['created_at'] = undefined;
/**
 * @member {Array.<module:model/CarrierDriver>} drivers
 */

_BaseCarrierRelationship["default"].prototype['drivers'] = undefined;
/**
 * @member {Boolean} exclude_from_automated_carrier_status
 */

_BaseCarrierRelationship["default"].prototype['exclude_from_automated_carrier_status'] = undefined;
/**
 * @member {String} external_payment_processor_id
 */

_BaseCarrierRelationship["default"].prototype['external_payment_processor_id'] = undefined;
/**
 * @member {module:model/BaseCarrierRelationship.ExternalPaymentProcessorSyncStatusEnum} external_payment_processor_sync_status
 */

_BaseCarrierRelationship["default"].prototype['external_payment_processor_sync_status'] = undefined;
/**
 * @member {module:model/FmcsaCensusData} fmcsa_census_data
 */

_BaseCarrierRelationship["default"].prototype['fmcsa_census_data'] = undefined;
/**
 * @member {module:model/Company} fmcsa_vendor
 */

_BaseCarrierRelationship["default"].prototype['fmcsa_vendor'] = undefined;
/**
 * @member {String} id
 */

_BaseCarrierRelationship["default"].prototype['id'] = undefined;
/**
 * @member {Array.<module:model/CarrierInsurance>} insurance_records
 */

_BaseCarrierRelationship["default"].prototype['insurance_records'] = undefined;
/**
 * @member {Boolean} is_editable
 */

_BaseCarrierRelationship["default"].prototype['is_editable'] = undefined;
/**
 * @member {String} notes
 */

_BaseCarrierRelationship["default"].prototype['notes'] = undefined;
/**
 * @member {Array.<module:model/CarrierPointOfContact>} point_of_contacts
 */

_BaseCarrierRelationship["default"].prototype['point_of_contacts'] = undefined;
/**
 * @member {module:model/Company} shipwell_vendor
 */

_BaseCarrierRelationship["default"].prototype['shipwell_vendor'] = undefined;
/**
 * @member {Array.<module:model/CarrierTag>} tags
 */

_BaseCarrierRelationship["default"].prototype['tags'] = undefined;
/**
 * @member {Date} updated_at
 */

_BaseCarrierRelationship["default"].prototype['updated_at'] = undefined;
/**
 * @member {module:model/VendorFactoringCompany} vendor_factoring_company
 */

_BaseCarrierRelationship["default"].prototype['vendor_factoring_company'] = undefined; // Implement SlimCarrierRelationshipAllOf interface:

/**
 * @member {Array.<module:model/SlimRMISCarrierStatus>} rmis_carrier_statuses
 */

_SlimCarrierRelationshipAllOf["default"].prototype['rmis_carrier_statuses'] = undefined;
/**
 * @member {Array.<module:model/SlimSaferWatchCarrierStatus>} saferwatch_carrier_statuses
 */

_SlimCarrierRelationshipAllOf["default"].prototype['saferwatch_carrier_statuses'] = undefined;
/**
 * Allowed values for the <code>carrier_status</code> property.
 * @enum {String}
 * @readonly
 */

SlimCarrierRelationship['CarrierStatusEnum'] = {
  /**
   * value: "ACTIVE"
   * @const
   */
  "ACTIVE": "ACTIVE",

  /**
   * value: "INACTIVE"
   * @const
   */
  "INACTIVE": "INACTIVE",

  /**
   * value: "DO_NOT_USE"
   * @const
   */
  "DO_NOT_USE": "DO_NOT_USE"
};
/**
 * Allowed values for the <code>external_payment_processor_sync_status</code> property.
 * @enum {String}
 * @readonly
 */

SlimCarrierRelationship['ExternalPaymentProcessorSyncStatusEnum'] = {
  /**
   * value: "CURRENT"
   * @const
   */
  "CURRENT": "CURRENT",

  /**
   * value: "SYNC_ERROR"
   * @const
   */
  "SYNC_ERROR": "SYNC_ERROR"
};
var _default = SlimCarrierRelationship;
exports["default"] = _default;